import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { loadCompanyAccounts } from '@epi-actions/api';
import { goToPage } from '@epi-actions/navigation';
import { useGetDetailsQuery } from '@epi-api/user';
import { routerPaths } from '@epi-constants/routerPaths';
import { getMainCompanyAccount } from '@epi-selectors/companyAccounts';
import { isSignatorySelector } from '@epi-selectors/login';
import { useEmailConfirmation } from '@epi-shared/hooks/useEmailConfirmation';
import { fetchActiveBenefits } from '@epi-store/benefitGroupSettings/benefitGroupSettings.slice';

export const useHome = () => {
  useEmailConfirmation();
  const { companyAccountId } = useSelector(getMainCompanyAccount);
  const { isLoading, data: customerData } = useGetDetailsQuery();
  const dispatch = useDispatch();
  const isSignatory = useSelector(isSignatorySelector);
  const isNewCustomer =
    customerData &&
    (customerData.isPbu
      ? !customerData.skipOnboarding
      : !(
          (customerData.isBenefitsSet &&
            customerData.isEmployeesSet &&
            (customerData.isMoneyTransfered || customerData.isLoadInitiated)) ||
          customerData.skipOnboarding
        ));

  useEffect(() => {
    if (!isSignatory) {
      dispatch(goToPage(routerPaths.orderHistory));
      return;
    }
  }, []);

  useEffect(() => {
    dispatch(loadCompanyAccounts());
    dispatch(fetchActiveBenefits());
  }, []);

  return {
    isLoading: isLoading || Boolean(!companyAccountId),
    isNewCustomer,
    customerData
  };
};
